import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import EnumField from "../ui/EnumField";
import { arrayToObject } from "../utils/Utils";

export default function POSChangeQuantities(props) {

    const { controller = "", route = "", callback = () => { }, invoice = "", pos_id = "", employee = "", sort = "" } = props;

    const [loading, setLoading] = useState(false);

    const defaults = [
        { key: "reverse_quantities", value: false },
        { key: "from_quantity", value: "" },
        { key: "to_quantity", value: "" },
        { key: "on_all", value: true }
    ];
    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs(defaults, "reverse_quantities");

    const changeQuantities = (_key = "", _value = "") => {

        let _obj = arrayToObject(tabs);
        if (_obj.hasOwnProperty(_key)) {
            _obj[_key] = _value;
        }

        if (index === "reverse_quantities") {
            // reverse quantities
            if (_value) {

                const _reverse_params = {
                    invoice: invoice,
                    pos_id: pos_id,
                    sort: sort,
                    limit: 40,
                    clerk_code: employee,
                    on_all: _obj.on_all,
                }
                setLoading(true);
                pubCall("point_of_sale.reverseQuantityOnAllItems", _reverse_params, (_s, _r) => {
                    if (_s) {
                        showMessage("Quantities reversed");
                        callback(_r);
                    } else {
                        showError(_r);
                    }
                    setLoading(false);
                });
            } else {
                // 
                callback(false);
            }

            return;
        } else {


            const _replace_params = {
                invoice: invoice,
                pos_id: pos_id,
                sort: sort,
                limit: 40,
                clerk_code: employee,
                from_quantity: parseInt(_obj.from_quantity) || null,
                to_quantity: parseInt(_obj.to_quantity) || null,
                on_all: _obj.on_all,
            }

            if (_replace_params.to_quantity === null) {
                showError({ error: "Need to set a quantity" });
                return;
            }

            setLoading(true);
            pubCall("point_of_sale.setQuantityOnAllItems", _replace_params, (_s, _r) => {
                if (_s) {
                    showMessage("Quantities set");
                    callback(_r);
                } else {
                    showError(_r);
                }
                setLoading(false);
            });


            return;
        }


    }


    const statusus = {
        reverse_quantities: "Yes / No:  +qty becomes -qty",
        from_quantity: "Blank to change all items",
        to_quantity: "Quantities will be changed to this",
        on_all: "<A>ll items or <F>rom this point on",
    };


    useEffect(() => {


        refs?.current?.[index]?.focus?.();
        refs?.current?.[index]?.select?.();


        const actions = [
            { key: KBD.ESCAPE, action: () => callback() },
            { key: KBD.ARROW_DOWN, action: () => next() },
            { key: KBD.ARROW_UP, action: () => prev() },
            { key: KBD.TAB, action: () => next() },
            { key: KBD.SHIFT_TAB, action: () => prev() }
        ]

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [index]);


    const yes_no = [
        { label: "Yes", value: true, key: KBD.Y },
        { label: "No", value: false, key: KBD.N }
    ];

    const all_from = [
        { label: "A", value: true, key: KBD.A },
        { label: "F", value: false, key: KBD.F }
    ];


    return (
        <div style={{ "width": "310px" }}>
            <Spin loading={loading}>
                <div className="shim" /><div className="shim" />
                <Space>
                    <Label width={250} >Reverse quantities?</Label>
                    <EnumField width={35} allow_empty={false} {...editProps("reverse_quantities")} onEnter={(e) => { update("reverse_quantities", e); next(); }} onPageDown={(e) => changeQuantities("reverse_quantities", e)} options={yes_no} />
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >Change quantities that were</Label>
                    <Input maxLength={4} width={35} {...editProps("from_quantity")} onEnter={(e) => { update("from_quantity", e); next(); }} onPageDown={(e) => changeQuantities("from_discount", e)} chars={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""]}></Input>
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >to</Label>
                    <Input maxLength={4} width={35} {...editProps("to_quantity")} onEnter={(e) => { update("to_quantity", e); next(); }} onPageDown={(e) => changeQuantities("to_discount", e)} chars={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""]}></Input>
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >All items from this point on?</Label>
                    <EnumField width={35} allow_empty={false} {...editProps("on_all")} onEnter={(e) => changeQuantities("on_all", e)} onPageDown={(e) => changeQuantities("on_all", e)} options={all_from} />
                </Space>
                <div className="shim" /><div className="shim" />
            </Spin>
            <div className="shim" />
            <Status type="active"><InfoIcon />{statusus[index]}</Status>
        </div>
    )
}